<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="title">Personnaliser les notifications</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <p class="notif-error-message">{{ notifErrorMessage }}</p>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>
              Recevoir les notifications de modification de l'annuaire par email
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p-switch v-model="notifActivated" @input="notifChanged">
              <i slot="on" class="fa fa-check" />
              <i slot="off" class="fa fa-times" />
            </p-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PSwitch from 'src/components/UIComponents/Switch.vue';
import VeeValidate, { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';

export default {
  name: 'EditUserProfileForm',
  components: {
    PSwitch,
  },
  props: {
    userEmail: String,
  },
  data() {
    return {
      notifActivated: true,
      notifErrorMessage: '',
    };
  },
  mounted() {
    this.fetchNotificationsActivated();
  },
  methods: {
    fetchNotificationsActivated() {
      // Get request to find out if the current user has activated notifications
      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/userNotificationEntities/search/existsByEmail?email=${this.userEmail}`,
        )
        .then(response => {
          this.notifActivated = response.data;
          this.notifErrorMessage = '';
        })
        .catch(error => {
          this.notifErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifChanged() {
      // Notify parent that notification configurtion has changed for that user
      this.$emit('notifChanged', this.notifActivated);
    },
  },
};
</script>
<style scoped>
.notif-error-message {
  margin-top: 10px;
  margin-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: darkred;
}
</style>
